import React, { useState, useEffect } from "react";
import { SkillsModalProps } from '../interFaces/interfaces';
const SkillsModal: React.FC<SkillsModalProps> = ({ isOpen, onClose, onSave, skills, selectedSkills }) => {
    const [localSelectedSkills, setLocalSelectedSkills] = useState<string[]>(selectedSkills);
    useEffect(() => {
        setLocalSelectedSkills(selectedSkills);
    }, [selectedSkills, isOpen]);
    const handleSkillToggle = (skillValue: string) => {
        setLocalSelectedSkills(prev =>
            prev.includes(skillValue)
                ? prev.filter(skill => skill !== skillValue)
                : [...prev, skillValue]
        );
    };
    const handleSelectAllToggle = () => {
        if (localSelectedSkills.length === skills.length) {
            setLocalSelectedSkills([]);
        } else {
            const allSkillValues = skills.map(skill => skill.value);
            setLocalSelectedSkills(allSkillValues);
        }
    };
    const handleSave = () => {
        onSave(localSelectedSkills);
        onClose();
    };
    if (!isOpen) return null;
    return (
        <div className="skills-modal-overlay" onClick={onClose}>
            <div className="skills-modal-content" onClick={e => e.stopPropagation()}>
                <div className="skills-modal-header">
                    <h3>Select Auditor Skills</h3>
                    <button className="skills-modal-close" onClick={onClose}>&times;</button>
                </div>
                <div className="skills-modal-body">
                    <div className="skills-select-all-container">
                        <label className="skills-checkbox-label">
                            <input type="checkbox" checked={localSelectedSkills.length === skills.length && skills.length > 0} onChange={handleSelectAllToggle} className="skills-checkbox-input" />
                            <span className="skills-checkbox-custom"></span>
                            <span className="skills-select-all-text">Select All</span>
                        </label>
                        <div className="skills-selected-count">
                            {localSelectedSkills.length} of {skills.length} selected
                        </div>
                    </div>
                    <div className="skills-list">
                        {skills.length === 0 ? (
                            <div className="skills-no-skills">No skills available</div>
                        ) : (
                            skills.map((skill) => (
                                <div key={skill.value} className="skills-skill-item">
                                    <label className="skills-checkbox-label">
                                        <input type="checkbox" checked={localSelectedSkills.includes(skill.value)} onChange={() => handleSkillToggle(skill.value)} className="skills-checkbox-input" />
                                        <span className="skills-checkbox-custom"></span>
                                        <span className="skills-skill-description">{skill.description}</span>
                                    </label>
                                </div>
                            ))
                        )}
                    </div>
                    <div className="buttons">
                        <button className="cancelbutton" onClick={onClose}>Cancel</button>
                        <button className="savebutton" onClick={handleSave}>Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SkillsModal;